import React, { useEffect, useState, useCallback, useRef,useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Redirect, withRouter } from 'react-router-dom';

import { Wizard } from '@xengage/gw-portals-wizard-react';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { Loader, useModal } from '@jutro/components';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { QuoteInfoComponentContext } from 'gw-capability-quoteandbind-common-react';
import { PECustomQuoteInfoComponent } from 'ml-capability-quoteandbind-common-react';
import { FormModalPopover, platformMessages as mlCommonMessages } from 'ml-components-platform-react';
import { MLTagManagerService, MLModalService } from 'ml-portals-services-react';
import { MLQuoteFlowUtil } from 'ml-portals-util-js';
import { MLAgentChoiceReportService } from 'gw-capability-gateway';
import { MLMultiLobsDataHolderService, MLStateRolloutService } from 'ml-services-common-react';
import { Submission } from 'gw-capability-quoteandbind';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { ClauseService } from 'gw-capability-policycommon';
import { MLLandingPageProvider } from 'gw-capability-gateway-quoteandbind-common-react';

import messages from './PEHOWizard.messages';
import wizardConfig from './config/ho-wizard-config.json5';
import crWizardConfig from './config/ho-wizard-comprater-config.json5';
import wizardStepToFieldMapping from './config/ho-wizard-step-to-field-mapping.json5';
import {MLPortalSettingsService} from "gw-capability-quoteandbind";

const PATH_TO_MOCK_DATA = 'quote.ho';
const MOCK_DATA_TO_SET = ['bindData.contactPhone'];
const MOCK_DATA_TO_REMOVE = ['bindData.contactPhone'];

function PEHOWizard(props) {
    const modalApi = useModal();
    const { steps, title } = wizardConfig;
    const { steps: crSteps, title: crTitle} = crWizardConfig;
    const { authHeader } = useAuthentication();
    const [initialSubmission, setInitialSubmission] = useState(null);
    const [hasErrorOccurred, setHasErrorOccurred] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isCREligible, setIsCREligible] = useState(undefined);
    const [shouldSkipValidSteps, setShouldSkipValidSteps] = useState(false);
    const { viewModelService, history, location } = props;
    const [isGroupAccessEligible, setIsGroupAccessEligible] = useState(undefined);

    let homeNewProductStates;
    const [newproductStates, setNewProductStates] = useState([]);


    const { showProgressDialog } = MLModalService()
    const { showReportModalWithSubmissionVM } = MLAgentChoiceReportService();
    const { cancel } = MLQuoteFlowUtil();

    const translator = useTranslator();

    const previousStep = useRef(MLMultiLobsDataHolderService.getLastVisitedStep());

    const viewModelContext = {
        AccountEmailRequired: false,
        DriverEmailRequired: true,
        AccountDOBRequired: false
    };

    const initSettings = async () => {
        if (!homeNewProductStates) {
            const response = await MLPortalSettingsService.getSettings(authHeader)
            if (response) {
                //home NP states
                homeNewProductStates = response.enableProperty50ProductStates;
                setNewProductStates(homeNewProductStates);
            }
        }
    };

    useEffect(() => {
        initSettings();
    }, []);

    useEffect(() => {
        if (_.has(location, 'state.submission') && isGroupAccessEligible === undefined) {
            const { submission } = location.state;
            MLStateRolloutService.checkIsGroupEnabled(submission?.baseData?.policyAddress?.state, authHeader).then((isGroupEligible) => {
                isGroupEligible = submission?.producerCodeOfRecord_ML?.producerType_ML === "ia" ? false : isGroupEligible;

                const isStrategicPartner = localStorage.getItem('strategicPartnershipInd_Ext');

                if (isStrategicPartner?.toLowerCase() === 'y') {
                    setIsGroupAccessEligible(false)
                }
                else {
                    setIsGroupAccessEligible(isGroupEligible)
                }                  
            });
        }
    }, [authHeader, isGroupAccessEligible, location]);

    useEffect(() => {
        if (initialSubmission){
            const isGCS = _.get(initialSubmission, 'producerCodeOfRecord_ML.producerType_ML.value.code') === 'gcs';
            
            MLStateRolloutService.checkIsCRWizardEligible(initialSubmission.quoteID.value, authHeader, isGCS).then((isCRWizardEligible) => {
                setIsCREligible(isCRWizardEligible);
            });
        }
    }, [initialSubmission, authHeader]);

    const updateInitialSubmission = useCallback((submission) => {
        setInitialSubmission(submission);
    }, [setInitialSubmission]);
    
    useEffect(() => {
        const visitedStep = MLMultiLobsDataHolderService.getLastVisitedStep();
        previousStep.current = visitedStep
    }, [MLMultiLobsDataHolderService.getLastVisitedStep()])

    useEffect(
        () => {
            if (!location.state) {
                history.push('/');
                return;
            }

            let submissionPromise;
            if (_.has(location, 'state.submission')) {
                const { submission, resumeFlow } = location.state;
                if (_.get(submission, 'baseData.sameMailingAddress_ML', 'undefined')) {
                    _.set(submission, 'baseData.sameMailingAddress_ML', true);
                }
                if (_.isUndefined(submission.baseData.priorAddressQuestion_Ext)) {
                    _.set(submission, 'baseData.priorAddressQuestion_Ext', false);
                }
                if (resumeFlow) {
                    setShouldSkipValidSteps(true);
                }
                submissionPromise = Promise.resolve(submission);
            } else {
                const { quoteentry } = location.state;
                const { postalCode, quoteID } = quoteentry;
                const requestData = {
                    quoteID: quoteID,
                    postalCode: postalCode
                };
                submissionPromise = LoadSaveService.retrieveSubmission(requestData, authHeader);
            }

            submissionPromise.then((response) => {
                MockUpUtil.cleanUpMockedProperties(
                    response,
                    PATH_TO_MOCK_DATA,
                    ...MOCK_DATA_TO_REMOVE
                );

                ClausesUtil.getDependentClausesFromServer(
                    ClauseService,
                    _.get(response, 'quoteID'),
                    authHeader
                );

                const submission = viewModelService.create(
                    new Submission(response),
                    'pc',
                    'edge.capabilities.quote.submission.dto.QuoteDataDTO',
                    viewModelContext
                );
                setInitialSubmission(submission);
                setIsLoading(false);
            });
            return () => {
                MLTagManagerService.setModel();
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const handleCancel = useCallback(
        (cancelProps) => {
            const skipModal = ['knockoutpage', 'logout', 'contactUs'];
            const {
                wizardSnapshot,
                param: nextPath = '',
                currentStepIndex,
                wizardData,
                steps: wizardSteps,
            } = cancelProps;
            const lastPathName = nextPath.replace(/\/?.*\//g, '');
            const quoteSummaryRegex = /^\/quotes\/[0-9]+\/summary/;
            const lastVisitedStep = MLMultiLobsDataHolderService.getLastVisitedStep();
            const isStatusQuoted = _.get(wizardData, 'baseData.periodStatus.value.code') === 'Quoted';
            const isBundle = _.get(wizardData, 'isBundle_ML.value') === true;

            // Don't display modal service for success page or if
            // next path matches /quotes/<job number>/summary
            if (
                currentStepIndex === wizardSteps.length - 1
                || skipModal.includes(lastPathName)
                || nextPath.match(quoteSummaryRegex)
                || hasErrorOccurred
            ) {
                return true;
            }

            // Allow transition to Bundle Cart, Account Summary, or Comp Rater Wizard
            if (nextPath.includes('/agent-bundle-cart') || nextPath.includes('/accounts') || nextPath.includes('/comp-wizard')) {
                return true;
            }

            if (nextPath.includes('/quoteentry')) {
                return true;
            }

            let modalMsg = mlCommonMessages.mlInfoWillBeSavedAsQuoteSubmission;
            if (!wizardData.quoteID.value) {
                modalMsg = mlCommonMessages.mlInfoWillNotBeSaved;
            } else if (!wizardData.quoteData.value) {
                modalMsg =mlCommonMessages.mlInfoSaveAsDraft;
            }

            return modalApi.showModal(
                <FormModalPopover
                    title={translator(mlCommonMessages.areYouSureYouWantToCancel)}
                    simpleMessage={translator(modalMsg)}
                    actionBtnLabel={commonMessages.yes}
                    cancelBtnLabel={mlCommonMessages.mlCancel}
                    closeSimpleMessage={false}
                />
            ).then(() => {
                setIsLoading(true);
                try {
                    const promise = cancel(wizardData, lastVisitedStep, showReportModalWithSubmissionVM, authHeader)
                    showProgressDialog(mlCommonMessages.saveSubmission, promise);
                    history.push(nextPath);
                    return true;
                } catch (error) {
                    history.push(nextPath);
                };
            }, _.noop);
        },
        [authHeader, cancel, hasErrorOccurred, history, modalApi, showProgressDialog, showReportModalWithSubmissionVM, translator]
    );

    const handleError = useCallback(
        (error) => {
            const isQuotePage = _.includes(_.toLower(_.get(error, 'gwInfo.method')), 'quote');
            const state = {
                pathname: '/contactUs',
                state: error
            };

            setHasErrorOccurred(true);
            return <Redirect push to={state} />
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const handleKnockout = useCallback(({ knockOutErrors }) => {
        history.push('/knockoutpage', { underwritingIssues: knockOutErrors });
    }, [history]);

    if (isLoading || isCREligible === undefined) {
        return <Loader loaded={!isLoading && isCREligible !== undefined} />;
    }

    if (!initialSubmission) {
        return null;
    }

    const submissionStatus = _.get(initialSubmission, 'baseData.status_ML.value');
    const isBindSubmission = !!_.get(initialSubmission, 'bindData.policyNumber.value') && (submissionStatus === 'Bound' || submissionStatus === 'Binding');
    const wizardLastVisitedStep = MLMultiLobsDataHolderService.getLastVisitedStep()
    const isFullQuote = !!wizardLastVisitedStep && !crSteps.find(step => step.mlStepName === wizardLastVisitedStep);
    const showCRSteps = _.get(initialSubmission, 'hvqQuoteID_ML.value') && !isFullQuote && isCREligible;
    let filteredSteps = steps;
    let crFilteredSteps = crSteps;


    const state = _.get(initialSubmission,'baseData.policyAddress.state.value.code')
    const isModernProduct = !!state && (newproductStates?.includes(state) || false)

    if (!showCRSteps && !isGroupAccessEligible) {
        // remove Group Affiliation screen from steps
        filteredSteps = steps.filter((step) =>
            step.mlStepName !== 'hoGroupAssociations' &&
            !(isModernProduct &&
                step.mlStepName === 'hoAddtlInfoToQuote'
            )
        );
    }

    if(isModernProduct && !showCRSteps && isGroupAccessEligible) {
        filteredSteps = steps.filter((step) =>
            step.mlStepName !== 'hoAddtlInfoToQuote'
        );
    }

    if(showCRSteps && !isGroupAccessEligible) {
        crFilteredSteps = crSteps.filter((step) => step.mlStepName !== 'compHoGroupAssociations');
    }

    const stepsToShow = showCRSteps ? crFilteredSteps : filteredSteps;

    return (
        <ErrorBoundary onError={handleError}>
            <QuoteInfoComponentContext.Provider value={PECustomQuoteInfoComponent}>
                <MLLandingPageProvider updateWizardSubmission={updateInitialSubmission}>
                    <Wizard
                        key={`PEHOWizard-${showCRSteps}`}
                        initialSteps={isBindSubmission ? [stepsToShow[stepsToShow.length -1]] : stepsToShow}
                        wizardTitle={showCRSteps ? crTitle: title}
                        onKnockOut={handleKnockout}
                        initialData={initialSubmission}
                        onCancel={handleCancel}
                        skipCompletedSteps={shouldSkipValidSteps}
                        wizardStepToFieldMapping={wizardStepToFieldMapping}
                        onPreviousModalProps={{
                            title: commonMessages.wantToJump,
                            message: commonMessages.wantToJumpMessage,
                            status: 'warning',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.yesModel,
                            cancelButtonText: commonMessages.cancelModel
                        }}
                    />
                </MLLandingPageProvider>
            </QuoteInfoComponentContext.Provider>
        </ErrorBoundary>
    );
}

PEHOWizard.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({
            quoteentry: PropTypes.shape({
                postalCode: PropTypes.string,
                quoteID: PropTypes.string
            })
        })
    }).isRequired
};

export default withRouter(withViewModelService(PEHOWizard));
